// extracted by mini-css-extract-plugin
module.exports = {"main-component":"retrospect_main-component__3tNJ-"};